import { apiClient } from '@/lib/api'
import type { QboConnectStart, QboStatus, QboSyncLogEntry } from '@/types/quickbooks'

export const fetchQboStatus = () => apiClient<QboStatus>('/quickbooks/status')

// The Intuit consent dialog redirects back to /settings/account with
// ?code&state&realmId; the SPA forwards them here.
export const qboCallback = (code: string, state: string, realmId: string) =>
  apiClient<QboStatus>('/quickbooks/callback', {
    method: 'POST',
    body: { code, state, realm_id: realmId },
  })

export const startQboConnect = () =>
  apiClient<QboConnectStart>('/quickbooks/connect/start', { method: 'POST' })

export const disconnectQbo = () =>
  apiClient<QboStatus>('/quickbooks/disconnect', { method: 'POST' })

export const fetchQboSyncLog = () =>
  apiClient<{ entries: QboSyncLogEntry[] }>('/quickbooks/sync-log')

export const syncQboNow = () =>
  apiClient<{ processed: number; pending: number }>('/quickbooks/sync-now', { method: 'POST' })
